import { getDynamicData, useObservable } from '@avensia/excite';

export function useCartIsLoading() {
  const dynamicDataObservable = getDynamicData<Excite.Commercetools.CartApiModel>();
  return useObservable(dynamicDataObservable.loading);
}
